import { Logger } from '~/helpers/logger';
import { Cart } from '~/modules/GraphQL/types';
import { VsfContext } from '~/composables/context';
import cartFields from './cartFragment.gql';

export const emptyCartCommand = {
  execute: async (
    context: VsfContext,
    {
      currentCart,
      customHeaders,
    },
  ) => {
   

    const uids = currentCart.items.map((cartItem) => cartItem.uid);

    if (!uids) {
      return;
    }

    const emptyCartParams = {
      cart_id: currentCart.id,
      cart_items: uids.map(uid => {
        return {
          cart_item_uid: uid, quantity:0
        }
      })
    };

    var clearCartMutation = `
mutation updateCartItems($input: UpdateCartItemsInput) {
  updateCartItems(input: $input) 
{
      cart {..CartFields}
    }
  }
    ${cartFields}
`;

    const { data } = await context.$magento.api.customQuery({
      query: clearCartMutation,
      queryVariables:{ input: emptyCartParams},
      customHeaders}
    );

    Logger.debug('[Result]:', { data });

    // eslint-disable-next-line consistent-return
    return (data as any)?.updateCartItems.cart as unknown as Cart;
  },
};
